import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {ServiceOffer, CartItem} from '../../../../data/model';
import {ServiceOfferFormComponent} from '../service-offer-form';
import {ServiceOfferStore} from '../../service-offer.store';
import {Subject, takeUntil} from 'rxjs';
import {Store, select} from '@ngrx/store';
import {selectCartItems} from 'src/app/common/shopping-cart/cart.selectors';

interface ServiceOfferSEPlayForm {
  addItemToCart: FormControl<boolean | null>;
  disclaimer: FormControl<boolean | null>;
}

@Component({
  selector: 'app-se-play-button',
  templateUrl: './se-play-button.component.html',
  styleUrls: ['./se-play-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {class: 'app-se-play-button-component'},
  standalone: false,
})
export class SePlayButtonComponent
  extends ServiceOfferFormComponent
  implements OnDestroy
{
  @Input() serviceOffer: ServiceOffer;

  offerForm = new FormGroup<ServiceOfferSEPlayForm>({
    addItemToCart: new FormControl<boolean>(false),
    disclaimer: new FormControl<boolean>(false),
  });
  showFormError = false;
  cartItems: CartItem[];

  readonly onDestroy = new Subject();

  constructor(
    protected ref: ChangeDetectorRef,
    private serviceOfferStore: ServiceOfferStore,
    private store: Store,
  ) {
    super(ref);
    this.store
      .pipe(select(selectCartItems), takeUntil(this.onDestroy))
      .subscribe(cartItems => (this.cartItems = cartItems));

    this.offerForm.valueChanges.subscribe(checked => {
      if (checked.addItemToCart) {
        this.showFormError = false;
      }
      this.ref.detectChanges();
    });
  }
  get agreementLabel(): string {
    return this.serviceOffer?.disclaimer || '';
  }

  get checkboxOptions(): Array<{label: string; value: boolean}> {
    return [{label: this.agreementLabel, value: true}];
  }

  get addItemToCartControl(): FormControl<boolean> {
    return this.offerForm.get('addItemToCart') as FormControl;
  }

  addToCartClicked(): void {
    this.showFormError = false;
    const sameItemInCart = this.cartItems.find(
      item => item.productId === this.value().productId,
    );
    if (this.addItemToCartControl.value && !sameItemInCart) {
      this.serviceOfferStore.addItemToCart(this.value());
    } else {
      this.showFormError = true;
    }
  }

  addonSelected(): boolean {
    return !!this.offerForm && !!this.offerForm.value.addItemToCart;
  }

  bindFormValue(selected: boolean): void {
    this.offerForm.setValue({addItemToCart: selected, disclaimer: selected});
  }

  valid(): boolean {
    return super.valid();
  }

  value(): CartItem {
    return super.value();
  }

  ngOnDestroy(): void {
    this.onDestroy.complete();
  }
}
